import AxiosManager from "../../../util/axiosLib/axiosManager";
import apiManager from "../../../utilNew/apiManager";


var apiUrl=process.env.VUE_APP_apiUrl +"/";
var apiPathBase="api/checkin/";


export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        return new apiManager(apiUrl,apiPathBase,"",this.getAxiosManager(),null)
    },

    // api_Test ( data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_CallMethod_ByParamObj("testPost",data)
    // },
    // api_Upload (file, data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_UpdateFile("upload",file,data)
    // },

    //---------------------------------------


    api_Event_Get (SystemId)
    {
        let data={
            SystemId:SystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Event_Get",data)
    },
    api_Event_Save (SystemId,jsonData)
    {
        let data={
            SystemId:SystemId,
            data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Event_Save",data)
    },
    api_Member_Get (SystemId)
    {
        let data={
            SystemId:SystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_Get",data)
    },
    api_Member_Save (SystemId,EventSystemId,jsonData)
    {
        let data={
            SystemId:SystemId,
            EventSystemId:EventSystemId,
            data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_Save",data)
    },
    api_Member_Save_CarNo (memberUuid,EventSystemId,CarNo)
    {
        let data={
            memberUuid:memberUuid,
            EventSystemId:EventSystemId,
            CarNo:CarNo,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_Save_CarNo",data)
    },
    api_Member_DeleteAll (eventSystemId)
    {
        let data={
            eventSystemId:eventSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_DeleteAll",data)
    },
    api_Member_Delete (memberSystemIds)
    {
        let data={
            memberSystemIds:memberSystemIds,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_Delete",data)
    },
    api_Member_Query (eventSystemId,searchKeyword)
    {
        let data={
            eventSystemId:eventSystemId,
            searchKeyword:searchKeyword,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_Query",data)
    },
    api_Member_QueryByEventItem (eventSystemId,eventItemSystemId)
    {
        let data={
            eventSystemId:eventSystemId,
            eventItemSystemId:eventItemSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_QueryByEventItem",data)
    },
    api_Member_Import ()
    {
        let data={
            // queryType:$queryType,
            // data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_Import",data)
    },
    api_Member_GenQR ()
    {
        let data={
            // queryType:$queryType,
            // data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_GenQR",data)
    },
    api_Event_GenQRCode (eventSystemId)
    {
        let data={
            eventSystemId:eventSystemId,
            // data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Event_GenQRCode",data)
    },
    api_MemberJoin_Entity_Add (memberSystemIds,eventSystemId,eventItemSystemIds)
    {
        let data={
            memberSystemIds:memberSystemIds,
            eventSystemId:eventSystemId,
            eventItemSystemIds:eventItemSystemIds,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("MemberJoin_Entity_Add",data)
    },
    api_MemberJoin_Entity_Remove (memberSystemIds,eventSystemId,eventItemSystemIds)
    {
        let data={
            memberSystemIds:memberSystemIds,
            eventSystemId:eventSystemId,
            eventItemSystemIds:eventItemSystemIds,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("MemberJoin_Entity_Remove",data)
    },
    api_MemberJoin_Entity_Sync (memberSystemIds,eventSystemId,eventItemSystemIds)
    {
        let data={
            memberSystemIds:memberSystemIds,
            eventSystemId:eventSystemId,
            eventItemSystemIds:eventItemSystemIds,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("MemberJoin_Entity_Sync",data)
    },
    api_MemberJoin_Entity_SyncMember (memberSystemId,jsonData)
    {
        let data={
            memberSystemId:memberSystemId,
            data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("MemberJoin_Entity_SyncMember",data)
    },
    api_Client_MemberInfo (memberSystemId)
    {
        let data={
            memberSystemId:memberSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Client_MemberInfo",data)
    },
    api_Client_MemberInfo_uuid (memberUuid)
    {
        let data={
            memberUuid:memberUuid,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Client_MemberInfo_uuid",data)
    },
    api_Client_ScanEventItem (memberUuid,eventSystemId,eventItemSystemId,CheckInExecBy,question1Answer,question2Answer,question3Answer)
    {
        let data={
            memberUuid:memberUuid,
            eventSystemId:eventSystemId,
            eventItemSystemId:eventItemSystemId,
            checkInExecBy:CheckInExecBy,
            question1Answer:question1Answer,
            question2Answer:question2Answer,
            question3Answer:question3Answer,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Client_ScanEventItem",data)
    },
    api_Client_CheckMemberCanCheckIn (eventSystemId,eventItemSystemId,memberUuid)
    {
        let data={
            eventSystemId:eventSystemId,
            eventItemSystemId:eventItemSystemId,
            memberUuid:memberUuid,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Client_CheckMemberCanCheckIn",data)
    },

    api_CheckInImportExcel (EventSystemId,fileUrlInServer)
    {
        let data={
            EventSystemId:EventSystemId,
            fileUrlInServer:fileUrlInServer,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("CheckInImportExcel",data)
    },

    api_CheckInImportExcel_TableNo (EventSystemId,fileUrlInServer)
    {
        let data={
            EventSystemId:EventSystemId,
            fileUrlInServer:fileUrlInServer,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("CheckInImportExcel_TableNo",data)
    },


    api_CheckInExportExcel (EventSystemId)
    {
        let data={
            EventSystemId:EventSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("CheckInExportExcel",data)
    },


    api_GetMemberIsCheckIn (EventSystemId,EventItemSystemId)
    {
        let data={
            EventSystemId:EventSystemId,
            EventItemSystemId:EventItemSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("GetMemberIsCheckIn",data)
    },


    api_Member_GenQRCode (memberSystemIds)
    {
        let data={
            memberSystemIds:memberSystemIds,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Member_GenQRCode",data)
    },


    async api_Download(fileUrl) {
        var apiPath=fileUrl;

        window.open(apiUrl+apiPath,"_blank")
    },

    async api_SendSMS(memberSystemId) {
        let data={
            memberSystemId:memberSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("SendSMS",data)
    },
}
